/*
  ducks-n-stuff — product cards swap to their second photograph on hover.

  The swap itself is CSS. This only attaches the source: the hover <img> is
  rendered without a src so a 60-product shop grid doesn't download twice the
  pixels, and the first hover (or keyboard focus) fills it in. The cross-fade
  waits for `data-loaded` so a half-arrived image never blanks the photo below.
*/
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;

  function loadHoverImage(card) {
    var img = card.querySelector('.dns-photo__alt:not([data-loading])');
    if (!img || !img.dataset.dnsHoverSrc) return;

    img.setAttribute('data-loading', '');
    if (img.dataset.dnsHoverSrcset) img.srcset = img.dataset.dnsHoverSrcset;
    img.src = img.dataset.dnsHoverSrc;

    if (img.complete && img.naturalWidth) {
      img.setAttribute('data-loaded', '');
      return;
    }
    img.addEventListener(
      'load',
      function () {
        img.setAttribute('data-loaded', '');
      },
      { once: true }
    );
  }

  function onPointer(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var card = target.closest('.dns-card');
    if (card) loadHoverImage(card);
  }

  document.addEventListener('mouseover', onPointer, { passive: true });
  document.addEventListener('focusin', onPointer);
})();
